import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { plainToClass } from 'class-transformer';

import { AccountManager } from 'app/shared/models/account-manager.model';

import { ClientsOverviewService } from './clients-overview.service';

@Component({
    templateUrl: './clients-overview.component.html',
    styleUrls: ['./clients-overview.component.css'],
    providers: [ClientsOverviewService]
})

export class ClientsOverviewComponent implements OnInit {

    accountManagers: AccountManager[];
    showAndHide: boolean[];

    constructor(
        private clientsOverviewService: ClientsOverviewService
        , private router: Router
    ) { }

    ngOnInit() {
        this.clientsOverviewService.getClients()
            .map(response => {
                return plainToClass(AccountManager, response.arrResult as Object[]);
            })
            .subscribe(
            success => {
                this.accountManagers = success;
                this.showAndHide = Array(this.accountManagers.length);
                for (let i = 0; i < this.showAndHide.length; i++) {
                    this.showAndHide[i] = false;
                }
            },
            err => {
                //TODO: must open snackbar 
            }
            );
    }

    toggleShowAndHide(index: number) {
        if (this.showAndHide[index]) {
            this.showAndHide[index] = false;
        } else {
            this.showAndHide[index] = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/clients/overview/clients-overview.component.ts